// extracted by mini-css-extract-plugin
export default {"container":"TestPage_container__xYa+Q","test_container":"TestPage_test_container__7HsUW","test_value":"TestPage_test_value__o3IO7"};